module.exports = "<div> <div class=main-title> <div class=title> <h1>{{title}}</h1> </div> </div> <div class=panel style=overflow:visible> <div class=panel-body> <div powerbi-scope-with-controller workspaceid={{workspaceId}} reportid={{reportId}}></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/portfolio/portfolioPowerbi/powerbi.html
// module id = 303
// module chunks = 0